/**
 * @author Littleor <me@littleor.cn>
 * @since 2022/7/10
 */
const verifyError = {
  zh: {
    A111P001: '人机验证失败, 请重试',
  },
  en: {
    A111P001: 'Human verification failed, please try again',
  },
}
export default verifyError
